import styled from 'styled-components'
import theme from '../../styles/theme.css'

export const ContainerImg = styled.div`
    width: 100%;
    max-width: 940px;
    margin: 2rem auto;
    img{
        max-width: 100%;
    }
    p{
        max-width: 100%!important;
        text-align: right;
        margin: 0.5rem 0;
        font-family: ${theme.plexMono};
        font-weight: 600;
        font-size: 0.7rem;
    }
    span{
        text-align: left;
        margin: 0.5rem 0;
        display: block;
        font-size: 0.8rem;
        max-width: 100%!important;
        font-family: ${theme.plexMono};
        font-weight: 600;
        font-size: 0.7rem;
    }
`